import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { RadioSharedModule } from '../../atoms/radio/radio.module';
import { FaIconSharedModule } from '../../atoms/fa.icon/fa.icon.module';
import { SearchFiltersSharedComponent } from './search.filters.component';
import { InputCalendarSharedModule } from '../../organisms/input.calendar/input.calendar.module';

@NgModule({
    declarations: [
        SearchFiltersSharedComponent
    ],
    imports: [
        FormsModule,
        CommonModule,
        RadioSharedModule,
        FaIconSharedModule,
        ReactiveFormsModule,
        InputCalendarSharedModule
    ],
    exports: [
        SearchFiltersSharedComponent
    ]
})

export class SearchFiltersSharedModule {}
